import { setUrl } from './setSharaUrl'
const wxReady = function(data) {
    wx.ready(function() {
        //分享特殊处理
        let sharaUrl = setUrl()
        let title = '上禾蛙hewa.cn，更多职位等你来',
            dec = '猎头上禾蛙—简历不浪费，职位不白费'
        if (data) {
            title = data.title
            dec = data.dec
        }
        wx.updateAppMessageShareData({
            title: title, // 分享标题
            desc: dec, // 分享描述
            link: sharaUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://hewa-public.obs.cn-north-1.myhuaweicloud.com/applet/images/wechat/wx_share_banner.png', // 分享图标
            success: function() {},
        })
        wx.updateTimelineShareData({
            title: title, // 分享标题
            desc: dec, // 分享描述
            link: sharaUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            // imgUrl: Vue.prototype.fileUrl+'/head_portrait/2020121015124001.jpg', // 分享图标
            imgUrl: 'https://hewa-public.obs.cn-north-1.myhuaweicloud.com/applet/images/wechat/wx_share_banner.png',
            success: function() {},
        })
    })

}
export default wxReady
